// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// 한국어 메시지 (v-data-table / v-pagination / no-data 등)
const koMessages = {
  badge: '배지',
  close: '닫기',
  dataIterator: {
    noResultsText: '일치하는 항목이 없습니다',
    loadingText: '불러오는 중...',
  },
  dataTable: {
    itemsPerPageText: '페이지당 항목 수:',
    ariaLabel: {
      sortDescending: '내림차순 정렬.',
      sortAscending: '오름차순 정렬.',
      sortNone: '정렬되지 않음.',
      activateNone: '정렬 제거.',
      activateDescending: '내림차순 정렬.',
      activateAscending: '오름차순 정렬.',
    },
    sortBy: '정렬 기준',
  },
  dataFooter: {
    itemsPerPageText: '페이지당 항목 수:',
    itemsPerPageAll: '전체',
    nextPage: '다음 페이지',
    prevPage: '이전 페이지',
    firstPage: '처음 페이지',
    lastPage: '마지막 페이지',
    pageText: '{0}-{1} / 전체 {2}개',
  },
  noDataText: '데이터가 없습니다',
  pagination: {
    ariaLabel: {
      root: '페이지 탐색',
      next: '다음 페이지',
      previous: '이전 페이지',
      page: '{0} 페이지로 이동',
      currentPage: '현재 {0} 페이지',
      first: '첫 페이지',
      last: '마지막 페이지',
    },
  },
  input: {
    clear: '{0} 지우기',
    prependAction: '{0} 앞 동작',
    appendAction: '{0} 뒤 동작',
    otp: 'OTP 문자 {0}번 입력',
  },
  fileInput: {
    counter: '파일 {0}개',
    counterSize: '파일 {0}개 ({1} / 총 {2})',
  },
}

/**
 * argong-manage-site Vuetify theme
 * Source: docs/ui-revamp/02-design-guide.md §2
 * Phase 1 — Foundation
 */
const argongAdmin = {
  dark: false,
  colors: {
    // Brand / CTA
    primary:    '#4482F0', // --color-primary-600
    secondary:  '#7A828F', // --text-tertiary (어드민에서 보조 텍스트/아이콘 톤)

    // Surfaces (v0.2)
    surface:    '#FAFAF8', // --bg-surface
    background: '#ECEEF2', // --bg-canvas

    // Status
    success: '#1F7A3A', // --color-success-text
    warning: '#92560A', // --color-warning-text
    error:   '#B42318', // --color-error-text
    info:    '#1B3F8A', // --color-info-text

    // Text helpers (Vuetify on-* 자동 계산 보완)
    'on-primary':    '#FFFFFF',
    'on-surface':    '#22252C',
    'on-background': '#22252C',
  },
}

export default createVuetify({
  locale: {
    locale: 'ko',
    fallback: 'en',
    messages: { ko: koMessages },
  },
  theme: {
    defaultTheme: 'argongAdmin',
    themes: {
      argongAdmin,
    },
  },
  defaults: {
    VBtn:  { rounded: 'md' },
    VCard: { rounded: 'md' },
    // 입력류는 outlined 강제 + 배경 --bg-surface-raised (글로벌 CSS에서 처리)
    VTextField:   { variant: 'outlined', density: 'comfortable' },
    VSelect:      { variant: 'outlined', density: 'comfortable' },
    VAutocomplete:{ variant: 'outlined', density: 'comfortable' },
    VCombobox:    { variant: 'outlined', density: 'comfortable' },
    VTextarea:    { variant: 'outlined', density: 'comfortable' },
  },
})
